export enum AutomationsRoles {
  VIEWER = 'roles.automationsViewer',

  // can create custom automations - requires subscription feature hasCustomAutomations
  CREATOR = 'roles.automationsCreator',
  EDITOR = 'roles.automationsEditor',
}
